// extracted by mini-css-extract-plugin
module.exports = {"thresholdTextField":"PerspectiveConfig-thresholdTextField-bc7de229e863c7fdda03b812740ed6b8"};